module.exports = __webpack_public_path__ + "assets/icon-nav-conversation-data-component.8a3f9bd3.svg";